import api from '../api'

const baseUrl = '/BizSchool/api/Discount'

const dadbanDiscountProvider = {
  getProductsTable(params) {
    return api.post(`${baseUrl}/ProductTable`, params)
  },

  getDiscount(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },

  addDiscount(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  updateDiscount(params = {}) {
    return api.post(`${baseUrl}/Edit`, params)
  },
}

export default dadbanDiscountProvider
